import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import {
  AiFillGithub,
  AiOutlineWhatsApp
} from "react-icons/ai";
import { MdOutlineEmail } from "react-icons/md";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={12} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              ABOUT <span className="purple"> US </span>
            </h1>
            <p className="home-about-body">
              At InfinityCode, we see software not as lines of code, but as the backbone of your
              ambition. We are the architects of the digital future, building elegant, powerful, and
              scalable solutions that propel businesses forward. We turn complex challenges into
              seamless experiences, unlocking infinite possibilities for growth, efficiency, and
              connection. Your vision is infinite. Your code should be too.🤷‍♂️
              <br />
              <br />We are fluent in classics and new technologies like
              <i>
                <b className="purple"> Javascript, Python and React. </b>
              </i>
              <br />
              <br />
              We like to build new &nbsp;
              <i>
                <b className="purple">Web Technologies and Products </b> and
                also in areas related to{" "}
                <b className="purple">
                  Business Management and Desition Making.
                </b>
              </i>
              <br />
              <br />
              Whenever possible, We also apply our passion for developing products
              with <b className="purple">Node.js</b> and
              <i>
                <b className="purple">
                  {" "}
                  Modern Javascript Library and Frameworks
                </b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js and Next.js</b>
              </i>
            </p>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND US</h1>
            <p>
              Feel free to <span className="purple">connect </span>with us
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/orgs/Koke-Forge-TM/dashboard"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://wa.me/17866447422"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineWhatsApp/>
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="mailto:infinitycodellc93@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <MdOutlineEmail />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
